var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "dashboard" } },
    [
      _c(
        "v-layout",
        { staticClass: "row wrap" },
        [
          _c(
            "v-flex",
            { staticClass: "xs12" },
            [
              _c(
                "v-btn",
                {
                  on: {
                    click: function($event) {
                      return _vm.addVisitors(48)
                    }
                  }
                },
                [_vm._v("+48")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  on: {
                    click: function($event) {
                      return _vm.addVisitors(1)
                    }
                  }
                },
                [_vm._v("+1")]
              ),
              _vm._v(" "),
              _c("pre", [
                _vm._v(
                  _vm._s(
                    _vm.$store.state._StoreWatcheeBox.listeAllVisiteurs.length
                  )
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { fab: "", color: "info" },
          on: {
            click: function($event) {
              return _vm.addNotif("info")
            }
          }
        },
        [_c("v-icon", [_vm._v("add")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { fab: "", color: "warning" },
          on: {
            click: function($event) {
              return _vm.addNotif("warning")
            }
          }
        },
        [_c("v-icon", [_vm._v("add")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { fab: "", color: "error" },
          on: {
            click: function($event) {
              return _vm.addNotif("error")
            }
          }
        },
        [_c("v-icon", [_vm._v("add")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { fab: "", color: "success" },
          on: {
            click: function($event) {
              return _vm.addNotif("success")
            }
          }
        },
        [_c("v-icon", [_vm._v("add")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { icon: "", large: "" },
          on: {
            click: function($event) {
              return _vm.CLEAR()
            }
          }
        },
        [_c("v-icon", [_vm._v("delete")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { icon: "", large: "" },
          on: {
            click: function($event) {
              return _vm.HIDE()
            }
          }
        },
        [_c("v-icon", [_vm._v("visibility_off")])],
        1
      ),
      _vm._v(" "),
      _c("pre", [_vm._v(_vm._s(_vm.index))]),
      _vm._v(" "),
      _c("pre", [_vm._v(_vm._s(_vm.$store.state._Notifier))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aae30ed8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aae30ed8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = null
// module chunks = 